module.exports = __webpack_public_path__ + "715bd9ea1501529e35fdf7656e9895d1.png";